import { useTranslation } from 'react-i18next';

import { ReactComponent as ActivityIcon } from '../../../assets/icons/activety-icon.svg';
import { ReactComponent as DotCircle } from '../../../assets/icons/dot-circle.svg';
import { ReactComponent as MoreIcon } from '../../../assets/icons/more-icon.svg';
import profile from '../../../assets/images/profiles/profile.jpg';
import { UserCardDetails } from '../../../interface/users-management.interface';
import DropDownMenu from '../../../shared-components/drop-down/DropDownMenu';

/**
 * User Card Body page function component
 * @param {any} properties - Properties
 * @returns {any} User card body component
 */
function UserCardBody(properties: UserCardDetails) {
  const { userDetails, activeLog, menuList, activeLogActive } = properties;
  const { t } = useTranslation('userRole');
  return (
    <div className="card-body">
      <div className="card-header">
        <div className="card-header-item-image">
          <img src={profile} alt="profile" />
        </div>
        <div className="card-header-item-title">
          <div className="title">{userDetails.name}</div>
          <div className="sub-title">{userDetails.accountId}</div>
        </div>
        <div className="card-header-item-tag">
          {(userDetails.isActive ?? userDetails.status) ? (
            <div className="tag-success-label">
              <DotCircle /> {t('active')}
            </div>
          ) : (
            <div className="tag-danger-label">
              <DotCircle /> {t('inactive')}
            </div>
          )}
        </div>
        <div className="card-header-item-icon">
          {menuList.filter((value) => value.allow).length > 0 && (
            <DropDownMenu
              list={menuList.map((value) => ({
                ...value,
                id: userDetails.id,
              }))}
              icon={<MoreIcon />}
            />
          )}
        </div>
      </div>
      <div className="card-body-content">
        <div className="user-details">
          <div className="title">{t('role')}</div>
          <div className="value">{userDetails.roleName}</div>
        </div>
        <div className="user-details">
          <div className="title">{t('date')}</div>
          <div className="value">{userDetails.createdAt}</div>
        </div>
        <div className="user-details">
          <div className="title">{t('contact')}</div>
          <div className="value">{userDetails.email}</div>
        </div>
      </div>
      {activeLogActive && (
        <div className="card-body-footer">
          <div className="button-wrap">
            <button
              type="button"
              className="back-button on-hover"
              onClick={(event: React.MouseEvent) => {
                event.stopPropagation();
                activeLog(userDetails.id, event);
              }}>
              <span>
                <ActivityIcon />
              </span>
              <span>{t('activityLog')}</span>
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default UserCardBody;
